module.exports = __webpack_public_path__ + "static/media/dtc.03e59cfe.svg";